var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.combineType,
              expression: "combineType",
            },
          ],
          attrs: { type: "radio", value: "0" },
          domProps: { checked: _vm._q(_vm.combineType, "0") },
          on: {
            change: function ($event) {
              _vm.combineType = "0"
            },
          },
        }),
        _vm._v(" препарат для продажи"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.combineType,
              expression: "combineType",
            },
          ],
          attrs: { type: "radio", value: "1" },
          domProps: { checked: _vm._q(_vm.combineType, "1") },
          on: {
            change: function ($event) {
              _vm.combineType = "1"
            },
          },
        }),
        _vm._v(" препарат состоит из нескольких\n    компонентов"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.combineType,
              expression: "combineType",
            },
          ],
          attrs: { type: "radio", value: "2" },
          domProps: { checked: _vm._q(_vm.combineType, "2") },
          on: {
            change: function ($event) {
              _vm.combineType = "2"
            },
          },
        }),
        _vm._v(" препарат не для продажи, так как является\n    компонентом"),
      ]),
    ]),
    _vm._v(" "),
    +_vm.combineType === 1
      ? _c(
          "div",
          [
            _c("DrugSearchNew", {
              ref: "drugForCombine",
              attrs: { onSelect: (d) => _vm.addDrugToCombine(d) },
            }),
            _vm._v(" "),
            _vm.combinedList.length
              ? _c("div", [
                  _c(
                    "table",
                    { staticClass: "table table-sm table-hover mt-1" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.combinedList, function (d, i) {
                          return _c("tr", [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(d.title))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: d.rate,
                                    expression: "d.rate",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number" },
                                domProps: { value: d.rate },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(d, "rate", $event.target.value)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromCombine(i)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-trash",
                                  }),
                                ]
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("количество")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }